// Opções dos filtros mockadas no front: o contrato do back não tem endpoint de
// opções. Telas e serviços ficam fixos aqui até haver fonte oficial.
import { formatScreenLabel, getAuditScreens } from '~/utils/auditCorrelation';
import { AUDIT_ALL, AuditOption } from './models';

// Telas auditadas por enquanto: itens do menu sob estes prefixos.
export const AUDIT_SCREEN_PREFIXES = [
  '/credit-table',
  '/consult/user',
  '/report',
  '/sales',
  '/file/documents',
];

const isAuditedRoute = (route: string) =>
  AUDIT_SCREEN_PREFIXES.some(
    (prefix) => route === prefix || route.startsWith(`${prefix}/`),
  );

export const getMockScreens = () =>
  getAuditScreens().filter(({ route }) => isAuditedRoute(route));

export const SCREEN_OPTIONS: AuditOption[] = [
  { id: AUDIT_ALL, value: 'Todas as telas' },
  ...getMockScreens().map((screen) => ({
    id: screen.route,
    value: formatScreenLabel(screen),
  })),
];

// Microsserviços do back, com o valor exato do campo `service` das atividades:
// é o `quarkus.kubernetes.name` de cada serviço no repositório opah-finan
// (finan/*/src/main/resources/application.properties). ms-api-cliente,
// ms-api-ficha-proposta, ms-api-integracao e ms-api-box-beneficio não definem a
// propriedade e vêm do ingress (infrastructure/kubernetes/ingresses).
// Levantado em 30/10/2026; revisar quando entrar um microsserviço novo.
export const MOCK_SERVICES = [
  'ms-api-access-control',
  'ms-api-agendamento',
  'ms-api-anfitriao',
  'ms-api-antecipacao',
  'ms-api-autorizador',
  'ms-api-beneficio',
  'ms-api-box-aumento-limite',
  'ms-api-box-base-cliente',
  'ms-api-box-beneficio',
  'ms-api-box-proposta',
  'ms-api-bureau',
  'ms-api-campanha',
  'ms-api-carteira',
  'ms-api-cliente',
  'ms-api-cobranca',
  'ms-api-dashboard',
  'ms-api-documento',
  'ms-api-email',
  'ms-api-empresa',
  'ms-api-emprestimo',
  'ms-api-estabelecimento',
  'ms-api-evento',
  'ms-api-evento-beneficio',
  'ms-api-faturamento',
  'ms-api-fechamento',
  'ms-api-ficha-proposta',
  'ms-api-funcionario',
  'ms-api-gestao-limite',
  'ms-api-historico',
  'ms-api-integracao',
  'ms-api-log',
  'ms-api-loja',
  'ms-api-motor',
  'ms-api-notificacao',
  'ms-api-pagamento',
  'ms-api-post',
  'ms-api-produto',
  'ms-api-push-notification',
  'ms-api-relatorio',
  'ms-api-s3bucket',
  'ms-api-schedule',
  'ms-api-topico',
  'ms-api-use-case',
  'ms-api-usuario',
  'ms-api-webhook',
  'ms-api-websocket',
];

export const SERVICE_OPTIONS: AuditOption[] = [
  { id: AUDIT_ALL, value: 'Todos os serviços' },
  ...MOCK_SERVICES.map((service) => ({ id: service, value: service })),
];

// Marcadores são sempre estes três (não equivalem a status HTTP).
export const MARKER_OPTIONS: AuditOption[] = [
  { id: AUDIT_ALL, value: 'Todos os marcadores' },
  { id: 'PERMITIDO', value: 'Permitido' },
  { id: 'NEGADO', value: 'Negado' },
  { id: 'SEM_REGISTRO', value: 'Sem registro' },
];
